import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ViewChild, OnInit } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/Core/services/auth.service';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

interface LogItem {
  id: number;
  log_type: string;
  ip: string;
  user_agent: string;
  agent: {
    id: number;
    name: string;
  };
  device?: {
    id: number;
    label: string;
  };
  user?: {
    id: number;
    name: string;
  };
  created: string;
}

interface Pager {
  total: number;
  per_page: number;
  current: number;
}

@Component({
  selector: 'app-log',
  templateUrl: './log-ctl.component.html'
})
export class LogComponent implements OnInit {
  public log: LogItem[] = [];
  logID: string = '';
  key: any;
  currentPage: number = 1;
  pageSize: number = 10;
  totalItems: number = 0;

  pageLoaded: boolean = false;

  ngOnInit(): void {
    this.route.paramMap.forEach((params) => {
      // this.userID = params.
      this.logID = params.get('id')!;
    });
    this.fetchLogData();
    this.pageLoaded = true;
  }

  rowData: LogItem[] = [];

  columnDefs: ColDef[] = [
    { lockPosition:'left',field: 'id', headerName: 'ID' },
    { lockPosition:'left',field: 'created', headerName: 'Time', cellRenderer: (params : any) => {
      const datePipe = new DatePipe('en-US');
      const formattedDate = datePipe.transform(params.value, 'yyyy-MM-dd HH:mm:ss');
      return formattedDate;
    },},
    { lockPosition:'left',field: 'ip', headerName: 'IP Address' },
    { lockPosition:'left',field: 'user_agent', headerName: 'Agent' },
    { lockPosition:'left',field: 'agent.name', headerName: 'Agent Name' },
    { lockPosition:'left',field: 'log_type', headerName: 'Log Type' },
  ];

  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    flex: 1,
    minWidth: 150,
    resizable: true,
    floatingFilter: false,
  };

  // Data that gets displayed in the grid
  public rowData$!: Observable<LogItem[]>;

  // For accessing the Grid's API
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private authService:AuthService
  ) { this.key=this.authService.getToken();}

  // Example load data from server
  onGridReady(params: GridReadyEvent) {}

  // Example using Grid's API
  clearSelection(): void {
    this.agGrid.api.deselectAll();
  }

  fetchLogData() {
    const apiUrl = `${environment.host}/log`;
    
    // Append the page number as a query parameter to the API URL
    const apiUrlWithPage = `${apiUrl}?page=${this.currentPage}`;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.key}`,
      'Content-Type': 'application/json',
    });

    this.http
      .get<{ items: LogItem[]; pager: Pager }>(apiUrlWithPage, { headers })
      .subscribe(
        (data) => {
          this.log = data.items;
          this.totalItems = data.pager.total;
          this.rowData = this.log;
        },
        (error) => {
          console.error('Error fetching log data:', error);
        }
      );
  }

  goToPage(pageNumber: number) {
    // Ensure the page number is within valid bounds
    this.currentPage = Math.min(Math.max(1, pageNumber), this.totalPages);

    // Fetch data for the new page
    this.fetchLogData();
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }
}
